import React, {Component} from 'react'
import FirebaseAuth from 'react-firebaseui/FirebaseAuth'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'react-responsive-modal/styles.css'
import {Modal} from 'react-responsive-modal'
import LaddaButton from './LaddaButton'

let defaultUiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
}

class LoginModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: this.props.open,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      open: nextProps.open,
    })
  }

  onOpenModal = () => {
    this.setState({open: true})
  }

  onCloseModal = () => {
    this.setState({open: false})
    this.props.onClose && this.props.onClose()
  }

  logout = () => {
    window.firebaseApp.auth().signOut()
    this.onCloseModal()
  }

  render() {
    const {open} = this.state
    let user = window.firebaseApp.auth().currentUser
    let signInSuccessUrl =
      this.props.signInSuccessUrl || window.location.pathname
    let uiConfig = Object.assign({}, defaultUiConfig, {
      signInSuccessUrl: signInSuccessUrl,
    })

    let children = user
    if (user) {
      children = (
        <div style={{minWidth: '100px'}}>
          <LaddaButton onClick={this.logout}>Log Out</LaddaButton>
        </div>
      )
    } else {
      children = [
        <h2 className="black" key="h2">
          Signup ou login avec Google.
        </h2>,
        <FirebaseAuth
          key="firebase-auth"
          uiConfig={uiConfig}
          firebaseAuth={window.firebaseApp.auth()}
        />,
      ]
    }
    return (
      <Modal open={open} onClose={this.onCloseModal}>
        {children}
      </Modal>
    )
  }
}

export default LoginModal



// WEBPACK FOOTER //
// ./src/components/LoginModal.jsx